




import Vue from 'vue';
import ProcessingStatusUsersDetail from '@/components/processing-status-users/processing-status-users-detail.component.vue';

export default Vue.extend({
  components: {
    'processing-status-users-detail': ProcessingStatusUsersDetail
  }
});
